<p-card class="mb-4">
  @if (isLoadingUsers) {
    <div class="flex justify-center">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  @if (!isLoadingUsers) {
    <form [formGroup]="form" (ngSubmit)="onSearch()">
      <div class="grid grid-cols-12 gap-4 justify-between">
        <div class="col-span-12 md:col-span-6 lg:col-span-2">
          <label class="sl-label">
            Programs
          </label>
          <p-fluid>
            <div class="sl-value">
              <p-select class="w-full" formControlName="productLob" tooltipPosition="bottom" [options]="productList" pTooltip="{{ programToolTip }}"></p-select>
            </div>
          </p-fluid>
        </div>
        <div class="col-span-12 md:col-span-6 lg:col-span-3">
          <label class="sl-label">
            Users
          </label>
          <p-fluid>
            <div class="sl-value">
              <p-multiSelect
                formControlName="selectedUser"
                multiselectOnSelectAll
                class="w-full"
                [displaySelectedLabel]="true"
                [options]="userNameList"
                [(ngModel)]="selectedUsers"
                (onPanelHide)="hideFilterPanel()"
              ></p-multiSelect>
            </div>
          </p-fluid>
        </div>
        <div class="col-span-12 md:col-span-6 lg:col-span-2">
          <label class="sl-label">
            Fax Status
          </label>
          <p-fluid>
            <div class="sl-value">
              <p-select class="w-full" formControlName="status" [options]="faxStatusList"></p-select>
            </div>
          </p-fluid>
        </div>
        <div class="col-span-12 md:col-span-6 lg:col-span-2">
          <label class="sl-label">
            Begin Date
          </label>
          <p-fluid>
            <div class="sl-value">
              <p-date-picker class="w-full" formControlName="startDate" placeholder="Start Date"></p-date-picker>
            </div>
          </p-fluid>
        </div>
        <div class="col-span-12 md:col-span-6 lg:col-span-2">
          <label class="sl-label">
            End Date
          </label>
          <p-fluid>
            <div class="sl-value">
              <p-date-picker class="w-full" formControlName="endDate" placeholder="End Date"></p-date-picker>
            </div>
          </p-fluid>
        </div>
        <div class="col-fixed self-end">
          <button
            class="p-button-action"
            id="fax-history-search-button"
            label="Submit"
            pButton
            type="submit"
            [disabled]="isLoading"
          ></button>
        </div>
      </div>
    </form>
  }
</p-card>
